export default {
    apiBaseURL: 'https://course-library-backend.herokuapp.com/api',
}
